/* eslint-disable eqeqeq */
/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable no-unused-vars */
import {
  Card,
  FormControl,
  Grid,
  InputLabel,
  MenuItem,
  Select,
  TextField,
} from "@mui/material";

import MDBox from "components/MDBox";
import MDButton from "components/MDButton";
import MDTypography from "components/MDTypography";
import { useMaterialUIController } from "context";
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import React, { useEffect, useState } from "react";
import { Link, useNavigate, useParams } from "react-router-dom";
import { getScreenRight } from "utils/generic";
import { blank } from "utils/generic";
import { useDispatch } from "react-redux";
import { getSubscriptionPlanById } from "utils/superAdminApi";
import { validateField } from "utils/generic";
import { addSubscriptionPlanData } from "utils/superAdminApi";
import { updateSubscriptionPlanData } from "utils/superAdminApi";
import { showResMsg } from "utils/generic";
import { genericMessage } from "utils/genericMessages";
import { formatCurrencyAUD } from "utils/formatCurrency";
import { formatNumberWithCommas } from "utils/formatCurrency";

const errMsg = {
  color: `red`,
  fontSize: `11px`
};

let routePath = "/subscriptionPlan";


function AddSubscriptionPlan() {

  const { id } = useParams();
  const [controller] = useMaterialUIController();
  const { sidenavColor, darkMode } = controller;
  const navigate = useNavigate()
  const dispatch = useDispatch()
  const [screenName, setScreenName] = useState('Add New Subscription Plan')
  const [planNameErr, setPlanNameErr] = useState(false);
  const [planCodeErr, setPlanCodeErr] = useState(false);
  const [planMonthlyCostErr, setPlanMonthlyCostErr] = useState(false);
  const [planSequenceErr, setPlanSequenceErr] = useState(false);
  const [planInUse, setPlanInUse] = useState(false);
  const [disableColor, setDisableColor] = useState(false);

  const [values, setValues] = React.useState({
    planName: '',
    planCode: '',
    planMonthlyCost: '',
    planSequence: '',
    planStatus: 'Active',
  });


  const handleChange = (name) => (event) => {
    if (name == "planCode") {
      setValues({ ...values, [name]: event.target.value.toUpperCase() });
      return
    }

    if (event.target.validity !== undefined && event.target.validity.valid === true) {
      setValues({ ...values, [name]: event.target.value });
    }
    else if (event.target.validity === undefined) {
      setValues({ ...values, [name]: event.target.value });
    }
  };

  useEffect(() => {
    id === undefined ? setScreenName("Add New Subscription Plan") : setScreenName("Edit Subscription Plan");
    (async () => {
      getRight()
      if (id !== undefined) {
        values._id = id
        getSubscriptionPlanById(values, (data) => {
          console.log("Sd", data)
          setValues(data.Result_Output);
          setPlanInUse(data.Result_Output.inUse);
        }, dispatch)
      }
    }
    )();
  }, [dispatch])


  async function getRight() {
    let right = await getScreenRight("Subscription Plans")
    if (right === "Full Access") {
      setDisableColor(false)
    }
    else setDisableColor(true)

  }

  const clearErrorStates = () => {
    setPlanNameErr(false);
    setPlanCodeErr(false);
    setPlanSequenceErr(false);
    setPlanMonthlyCostErr(false);
  };

  const SubscriptionPlan = async () => {
    let mandateFlag = false;
    clearErrorStates();
    mandateFlag = validateField(values.planName, setPlanNameErr) || mandateFlag;
    mandateFlag = validateField(values.planCode, setPlanCodeErr) || mandateFlag;
    mandateFlag = validateField(values.planSequence, setPlanSequenceErr) || mandateFlag;
    mandateFlag = validateField(values.planMonthlyCost, setPlanMonthlyCostErr) || mandateFlag;
    if (mandateFlag) {
      return;
    }
    const apiFunction = id === undefined ? addSubscriptionPlanData : updateSubscriptionPlanData;
    apiFunction(values, (data) => {
      if (data.Result_Status) {
        showResMsg(id === undefined ? genericMessage.added : genericMessage.updated, 1000, data.Result_Status, navigate, routePath);
      } else {
        showResMsg(data.Result_Message, 2000, data.Result_Status);
      }
    }, dispatch);
  };

  useEffect(() => {
    document.addEventListener('keydown', handleKeyDown);
    return () => {
      document.removeEventListener('keydown', handleKeyDown);
    };
  }, []);


  const handleKeyDown = (e) => {
    const inputElement = document.querySelector('.GoogleInput');
    if (e.key === "Enter" && inputElement && inputElement.contains(e.target)) {
      e.preventDefault();
    }
  };



  return (
    <DashboardLayout>
      <DashboardNavbar screenName={screenName} />
      <MDBox mt={6} mb={3}>
        <Grid container spacing={1} style={{ display: "flex", justifyContent: "center" }}>
          <Grid item lg={8} xs={12}>
            <Card sx={{ boxShadow: "none" }}>
              <MDBox
                mx={2}
                mt={-3}
                mb={1.5}
                py={2}
                px={2}
                variant="gradient"
                bgColor={sidenavColor}
                borderRadius="lg"
                coloredShadow="info"
              >
                <MDTypography variant="h6" color="white">
                  {screenName}
                </MDTypography>
              </MDBox>
              <Grid
                container
                p={1.6}
                mb={0.9}
                px={2}
                columnSpacing={{ xs: 2, sm: 2, md: 3, lg: 3 }}
                rowSpacing={{ xs: 2, sm: 2, md: 3, lg: 3 }}
              >
                <Grid item lg={6} xs={12}>
                  <TextField
                    type="text"
                    label="Plan Name"
                    variant="outlined"
                    fullWidth
                    autoFocus={true}
                    value={values.planName} onChange={handleChange('planName')}
                    inputProps={{
                      pattern: "^[a-zA-Z ]+$",
                      maxLength: 30
                    }}

                  />
                  {planNameErr ? <span style={errMsg}>Plan Name can't be blank</span> : ""}
                </Grid>
                <Grid item lg={3} xs={12}>
                  <TextField
                    type="text"
                    label="Plan Code"
                    variant="outlined"
                    fullWidth
                    value={values.planCode}
                    onChange={handleChange('planCode')}
                    inputProps={{
                      pattern: "^[A-Za-z0-9]+$",
                      maxLength: 30

                    }}
                  />
                  {planCodeErr ? <span style={errMsg}>Plan Code can't be blank</span> : ""}
                </Grid>
                <Grid item lg={3} xs={12}>
                  <TextField
                    type="text"
                    label="Plan Sequence"
                    variant="outlined"
                    fullWidth
                    value={values.planSequence} onChange={handleChange('planSequence')}
                    inputProps={{
                      pattern: "^[0-9]+$",
                      maxLength: 2
                    }}
                  />
                  {planSequenceErr ? <span style={errMsg}>Plan Sequence can't be blank</span> : ""}
                </Grid>

                <Grid item lg={6} xs={12}>
                  <TextField
                    type="text"
                    label="Plan Monthly Cost ($)"
                    variant="outlined"
                    fullWidth
                    // value={formatNumberWithCommas(values.planMonthlyCost)}
                    value={values.planMonthlyCost}
                    onChange={handleChange('planMonthlyCost')}
                    // disabled={id !== undefined}
                    inputProps={{
                      pattern: "^[0-9.]+$",
                      maxLength: 6
                    }}
                  />
                  {planMonthlyCostErr ? <span style={errMsg}>Plan Monthly Cost ($) can't be blank</span> : ""}
                  {/* {emailAddressErrMsg !== "" ? <span style={errMsg}>{emailAddressErrMsg}</span> : ""} */}
                </Grid>
                <Grid item lg={6} xs={12}>
                  <FormControl fullWidth>
                    <InputLabel id="userStatus">Plan Status </InputLabel>
                    <Select
                      labelId="demo-simple-select-label"
                      id="demo-simple-select"
                      style={{ minHeight: "44.11px" }}
                      label="Plan Status"
                      value={values.planStatus} onChange={handleChange('planStatus')}
                      disabled={planInUse}
                    >
                      <MenuItem value="Active">Active</MenuItem>
                      <MenuItem value="Inactive">Inactive</MenuItem>
                    </Select>
                  </FormControl>
                </Grid>
              </Grid>
            </Card>

          </Grid>
        </Grid>
        <Grid
          container
          mt={2}
          columnSpacing={{ xs: 2, md: 4, lg: 4 }}
          // columnSpacing={4}
          alignItems="center"
          display="flex"
          justifyContent="center"
        >
          <Grid item xs={12} md={4} lg={1.67}>

            <Link to={"/subscriptionPlan"}>
              <MDButton
                className="btn-block center-container-btn btn-warning btn-back rightSpace"
                color="warning"
                fullWidth
                style={{ width: "165px", height: "40px" }}
              >
                Cancel
              </MDButton>
            </Link>
          </Grid>
          <Grid item xs={12} md={4} spacing={2} lg={1.67}>
            <MDButton
              onClick={disableColor ? blank : SubscriptionPlan}
              rel="noreferrer"
              variant="gradient"
              className={"btn-block center-container-btn btn-warning btn-back rightSpace"}
              color={disableColor ? "secondary" : "success"}
              fullWidth
              style={{ width: "165px", height: "40px" }}
            >
              {id !== undefined ? <>Update</> : <>Save</>}

            </MDButton>
          </Grid>

        </Grid>
      </MDBox>

    </DashboardLayout>
  );
}

export default AddSubscriptionPlan;
